<div class="overflow-hidden rounded border border-aux-gray-dark">
  <div class="p-4 2xl:p-6">
    <ng-content></ng-content>
  </div>
  <div class="bg-aux-gray-light p-4 2xl:p-6">
    <div class="mb-4 flex items-center justify-between">
      <div class="font-bold text-aux-black">Alerts</div>
      <div class="flex items-center space-x-4">
        <button class="text-sm font-medium text-aux-blue underline">View All</button>
        <button class="text-sm font-medium text-aux-blue underline" (click)="onManage()">
          Manage
        </button>
      </div>
    </div>

    <div class="space-y-4">
      @for (alert of alerts; track alert) {
        <div class="flex space-x-4">
          <div>
            <div
              class="h-4 w-4 rounded-full"
              [ngClass]="{
                'bg-aux-error': alert.color === 'red',
                'bg-aux-green': alert.color === 'green',
              }"
            ></div>
          </div>

          <div class="text-sm text-aux-black">
            {{ alert.message }}
          </div>
        </div>
      }
    </div>
  </div>
</div>
